// import Axios from "axios";
// import useAxios, { configure } from "axios-hooks";
// import Swal from "sweetalert2";
// import { apiErrorToast, toastWithTimer } from "../utils/ToastUtil";
// import { checkNetwork } from "../utils/NatworkUtil";
// import { BASE_URL } from "./ApiEndPoints";
// import LRU from "lru-cache";
// import HashPayload from "../utils/HashPayload";

// const cache = new LRU({ max: 10 });

// let axios;
// const deleteUser = () => {
//   localStorage.removeItem("access_token");
//   localStorage.removeItem("user");
//   localStorage.removeItem("user_nepal");
//   localStorage.removeItem("nepal_token");
//   localStorage.removeItem("location");
//   localStorage.removeItem("docs");
//   localStorage.removeItem("MoneyTransfer");
//   localStorage.removeItem("items");
//   localStorage.removeItem("subIndex");
//   localStorage.removeItem("selectedRow");
//   localStorage.removeItem("index");
//   setTimeout(() => {
//     window.open("/login", "_self");
//   }, 100);
// };

// export const getAxios = (token = null) => {
//   if (!token) {
//     token = localStorage.getItem("access_token");
//   }
//   axios = Axios.create({
//     baseURL: BASE_URL,
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token && token}`,
//     },
//   });
//   configure({ axios, cache });

//   axios.interceptors.request.use(
//     function (config) {
//       // Do something before request is sent
//       //console.log(config);
//       config.headers["Content-Type"] = "application/json";
//       //alert("Token set");
//       return config;
//     },

//     function (error) {
//       // Do something with request error
//       // console.log(error);
//       return Promise.reject(error);
//     }
//   );
//   return axios;
// };
// // self invoke for first time
// getAxios();
// export const useAx = (endpoint) => {
//   return useAxios(endpoint);
// };

// export const onInValidAuth = (error, next) => {
//   // alert(JSON.stringify(error.response));
//   if (error.response && error.response.status === 401) {
//     // alert(error.response.message);
//     Swal.fire("Unathorized, you need to Relogin.");
//     deleteUser();
//     // history.pushState(history.state, "login", "/login");
//     // location.reload();
//   }
//   //alert("error " + error);
//   if (next) {
//     next(error);
//   } else {
//     apiErrorToast(error);
//   }
// };
// export const postFormData = (
//   endpoint,
//   formData,
//   setIsProgress,
//   onSuccess,
//   onError
// ) => {
//   if (setIsProgress) setIsProgress(true);
//   if (!checkNetwork()) {
//     if (setIsProgress) setIsProgress(false);
//     toastWithTimer(
//       '<div class="styled-msg">Kindly login again<strong class="redbox"></strong></div>',
//       5000,
//       "Network connection error",
//       deleteUser
//     );
//     // Swal.fire("Check your network Connection!!!");
//     return false;
//   }
//   axios
//     .post(endpoint, formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//       },
//     })
//     .then((response) => {
//       const data = response;
//       onSuccess(data);
//       if (setIsProgress) setIsProgress(false);
//     })
//     .catch((error) => {
//       if (setIsProgress) setIsProgress(false);
//       onInValidAuth(error, onError);
//     });
// };

// export const postFormDataQuery = (
//   endpoint,
//   formData,
//   setIsProgress,
//   onSuccess,
//   onError,
//   query
// ) => {
//   if (setIsProgress) setIsProgress(true);
//   if (!checkNetwork()) {
//     if (setIsProgress) setIsProgress(false);
//     toastWithTimer(
//       '<div class="styled-msg">Kindly login again<strong class="redbox"></strong></div>',
//       5000,
//       "Network connection error",
//       deleteUser
//     );
//     // Swal.fire("Check your network Connection!!!");
//     return false;
//   }
//   axios
//     .post(endpoint, formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//       },
//       params: query,
//     })
//     .then((response) => {
//       const data = response;
//       onSuccess(data);
//       if (setIsProgress) setIsProgress(false);
//     })
//     .catch((error) => {
//       if (setIsProgress) setIsProgress(false);
//       onInValidAuth(error, onError);
//     });
// };
// export const putFormData = (
//   id,
//   endpoint,
//   formData,
//   setIsProgress,
//   onSuccess,
//   onError
// ) => {
//   setIsProgress(true);
//   if (!checkNetwork()) {
//     if (setIsProgress) setIsProgress(false);
//     toastWithTimer(
//       '<div class="styled-msg">Kindly login again<strong class="redbox"></strong></div>',
//       5000,
//       "Network connection error",
//       deleteUser
//     );
//     // Swal.fire("Check your network Connection!!!");
//     return false;
//   }
//   axios
//     .put(endpoint + "/" + id, formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//       },
//     })
//     .then((response) => {
//       const data = response.data;
//       onSuccess(data);
//       setIsProgress(false);
//     })
//     .catch((error) => {
//       setIsProgress(false);
//       onInValidAuth(error, onError);
//     });
// };

// export const putJsonData = (
//   endpoint,
//   jsonData,
//   queryString,
//   setIsProgress,
//   onSuccess,
//   onError
// ) => {
//   setIsProgress(true);
//   if (!checkNetwork()) {
//     if (setIsProgress) setIsProgress(false);
//     toastWithTimer(
//       '<div class="styled-msg">Kindly login again<strong class="redbox"></strong></div>',
//       5000,
//       "Network connection error",
//       deleteUser
//     );
//     // Swal.fire("Check your network Connection!!!");
//     return false;
//   }
//   axios
//     .put(`${endpoint}${queryString && queryString + "/"}`, jsonData, {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//       },
//     })
//     .then((response) => {
//       const data = response;
//       onSuccess(data);
//       setIsProgress(false);
//     })
//     .catch((error) => {
//       setIsProgress(false);
//       onInValidAuth(error, onError);
//     });
// };

// export const postJsonData = (
//   endpoint,
//   jsonData,
//   setIsProgress,
//   onSuccess,
//   onError
// ) => {
//   // Uncomment below line to implement payload hash
//   jsonData = HashPayload(jsonData);
//   if (setIsProgress) setIsProgress(true);
//   if (!checkNetwork()) {
//     if (setIsProgress) setIsProgress(false);
//     toastWithTimer(
//       '<div class="styled-msg">Kindly login again<strong class="redbox"></strong></div>',
//       5000,
//       "Network connection error",
//       deleteUser
//     );
//     // Swal.fire("Check your network Connection!!!");
//     return false;
//   }
//   return axios
//     .post(
//       endpoint,
//       jsonData,

//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           Cookie: "cookie1-value;",
//         },
//       },

//       { withCredentials: true }
//     )
//     .then((response) => {
//       const data = response;

//       onSuccess(data);
//       if (setIsProgress) setIsProgress(false);
//     })
//     .catch((error) => {
//       // Swal.fire("post error", JSON.stringify(JSON.stringify(error.message)));
//       if (error && error.message === "Network Error") {
//         // history.pushState(history.state, "login", "/login");
//         // location.reload();
//       } else {
//         if (setIsProgress) setIsProgress(false);
//         onInValidAuth(error, onError);
//       }
//       if (setIsProgress) setIsProgress(false);
//     });
// };
// export const postJsonDataQuery = (
//   endpoint,
//   jsonData,
//   setIsProgress,
//   onSuccess,
//   onError,
//   query
// ) => {
//   if (setIsProgress) setIsProgress(true);
//   //console.log("data => "+JSON.stringify(jsonData))
//   if (!checkNetwork()) {
//     if (setIsProgress) setIsProgress(false);
//     toastWithTimer(
//       '<div class="styled-msg">Kindly login again<strong class="redbox"></strong></div>',
//       5000,
//       "Network connection error",
//       deleteUser
//     );
//     // Swal.fire("Check your network Connection!!!");
//     return false;
//   }
//   return axios
//     .post(endpoint, jsonData, {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//       },
//       params: query,
//     })
//     .then((response) => {
//       const data = response;
//       // console.log("api response=> ", JSON.stringify(response));
//       // okSuccessToast("Success", JSON.stringify(data));
//       onSuccess(data);
//       if (setIsProgress) setIsProgress(false);
//     })
//     .catch((error) => {
//       // Swal.fire("post error", JSON.stringify(JSON.stringify(error.message)));
//       if (error && error.message === "Network Error") {
//         // history.pushState(history.state, "login", "/login");
//         // location.reload();
//       } else {
//         if (setIsProgress) setIsProgress(false);
//         onInValidAuth(error, onError);
//       }
//       if (setIsProgress) setIsProgress(false);
//     });
// };
// export const deleteJsonData = (
//   endpoint,
//   jsonData,
//   queryString,
//   setIsProgress,
//   onSuccess,
//   onError
// ) => {
//   console.log("req body", jsonData);
//   if (setIsProgress) setIsProgress(true);
//   if (!checkNetwork()) {
//     if (setIsProgress) setIsProgress(false);
//     toastWithTimer(
//       '<div class="styled-msg">Kindly login again<strong class="redbox"></strong></div>',
//       5000,
//       "Network connection error",
//       deleteUser
//     );
//     // Swal.fire("Check your network Connection!!!");
//     return false;
//   }
//   axios
//     .delete(`${endpoint}${queryString && `${queryString}`}`, {
//       data: jsonData,
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//       },
//     })
//     .then((response) => {
//       const data = response;
//       onSuccess(data);
//       if (setIsProgress) setIsProgress(false);
//     })
//     .catch((error) => {
//       if (setIsProgress) setIsProgress(false);
//       onInValidAuth(error, onError);
//     });
// };
// export const getRequest = (endpoint, setIsProgress, onSuccess, onError) => {
//   if (setIsProgress) setIsProgress(true);
//   if (!checkNetwork()) {
//     if (setIsProgress) setIsProgress(false);
//     toastWithTimer(
//       '<div class="styled-msg">Kindly login again<strong class="redbox"></strong></div>',
//       5000,
//       "Network connection error",
//       deleteUser
//     );
//     // Swal.fire("Check your network Connection!!!");
//     return false;
//   }
//   axios
//     .get(endpoint, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//       },
//     })
//     .then((response) => {
//       const data = response;
//       onSuccess(data);
//       if (setIsProgress) setIsProgress(false);
//     })
//     .catch((error) => {
//       if (setIsProgress) setIsProgress(false);
//       onInValidAuth(error, onError);
//     });
// };
// export const get = (
//   endpoint,
//   queryString,
//   setIsProgress,
//   onSuccess,
//   onError
// ) => {
//   if (setIsProgress) setIsProgress(true);
//   if (!checkNetwork()) {
//     if (setIsProgress) setIsProgress(false);
//     toastWithTimer(
//       '<div class="styled-msg">Kindly login again<strong class="redbox"></strong></div>',
//       5000,
//       "Network connection error",
//       deleteUser
//     );
//     // Swal.fire("Check your network Connection!!!");
//     return false;
//   }
//   axios
//     .get(`${endpoint}${queryString && `?${queryString}`}`, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//       },
//     })
//     .then((response) => {
//       const data = response;
//       onSuccess(data);
//       if (setIsProgress) setIsProgress(false);
//     })
//     .catch((error) => {
//       onInValidAuth(error, onError);
//       if (setIsProgress) setIsProgress(false);
//     });
// };
// export const patchJsonData = (
//   endpoint,
//   jsonData,
//   pathParam,
//   setIsProgress,
//   onSuccess,
//   onError
// ) => {
//   if (setIsProgress) setIsProgress(true);
//   //console.log("data => "+JSON.stringify(jsonData))
//   if (!checkNetwork()) {
//     if (setIsProgress) setIsProgress(false);
//     toastWithTimer(
//       '<div class="styled-msg">Kindly login again<strong class="redbox"></strong></div>',
//       5000,
//       "Network connection error",
//       deleteUser
//     );
//     // Swal.fire("Check your network Connection!!!");
//     return false;
//   }
//   return axios
//     .patch(`${endpoint}${pathParam && pathParam + "/"}`, jsonData, {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//       },
//     })
//     .then((response) => {
//       const data = response;

//       onSuccess(data);
//       if (setIsProgress) setIsProgress(false);
//     })
//     .catch((error) => {
//       // Swal.fire("post error", JSON.stringify(JSON.stringify(error.message)));
//       if (error && error.message === "Network Error") {
//         // history.pushState(history.state, "login", "/login");
//         // location.reload();
//       } else {
//         if (setIsProgress) setIsProgress(false);
//         onInValidAuth(error, onError);
//       }
//     });
// };

// export const loginApi = (
//   endpoint,
//   jsonData,
//   setIsProgress,
//   onSuccess,
//   onError
// ) => {
//   if (setIsProgress) setIsProgress(true);
//   axios
//     .post(endpoint, jsonData, {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `null`,
//       },
//     })
//     .then((response) => {
//       const data = response;
//       onSuccess(data);
//       if (setIsProgress) setIsProgress(false);
//     })
//     .catch((error) => {
//       onInValidAuth(error, onError);
//       if (setIsProgress) setIsProgress(false);
//     });
// };

import Axios from "axios";
import useAxios, { configure } from "axios-hooks";
import Swal from "sweetalert2";
import { apiErrorToast, toastWithTimer } from "../utils/ToastUtil";
import { checkNetwork } from "../utils/NatworkUtil";
import { BASE_URL } from "./ApiEndPoints";
import LRU from "lru-cache";
import HashPayload from "../utils/HashPayload";

const cache = new LRU({ max: 10 });
const createAxiosInstance = () => {
  const instance = Axios.create({
    baseURL: BASE_URL,
    timeout: 30000,
    headers: { "Content-Type": "application/json" },
  });

  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.metadata = { startTime: Date.now() };
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      // ⛔ Abort (component unmount / manual cancel)
      if (error.code === "ERR_CANCELED") {
        console.log("Request aborted:", error.config?.url);
        return Promise.reject(error);
      }

      // ⛔ Timeout
      if (error.code === "ECONNABORTED") {
        return Promise.reject(new Error("REQUEST_TIMEOUT"));
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

// Initialize axios instance
let axios = createAxiosInstance();
configure({ axios, cache });

const deleteUser = () => {
  const itemsToRemove = [
    "access_token",
    "user",
    "user_nepal",
    "nepal_token",
    "location",
    "docs",
    "MoneyTransfer",
    "items",
    "subIndex",
    "selectedRow",
    "index",
  ];

  itemsToRemove.forEach((item) => localStorage.removeItem(item));

  setTimeout(() => {
    window.location.href = "/login";
  }, 100);
};

export const getAxios = () => {
  // Refresh token in existing instance
  const token = localStorage.getItem("access_token");
  axios.defaults.headers.common["Authorization"] = token
    ? `Bearer ${token}`
    : "";
  return axios;
};

export const useAx = (endpoint) => {
  return useAxios(endpoint);
};

export const onInValidAuth = (error, next) => {
  // Don't show error for canceled requests
  if (Axios.isCancel(error)) {
    console.log("Request was canceled, skipping error handling");
    return;
  }

  if (error.response?.status === 401) {
    Swal.fire({
      title: "Session Expired",
      text: "Your session has expired. Please login again.",
      icon: "warning",
      confirmButtonText: "OK",
    }).then(() => {
      deleteUser();
    });
    return;
  }

  if (error.response?.status === 429) {
    Swal.fire({
      title: "Too Many Requests",
      text: "Please wait a moment before trying again.",
      icon: "warning",
      confirmButtonText: "OK",
    });
    return;
  }

  if (next) {
    next(error);
  } else {
    apiErrorToast(error);
  }
};

// Helper function for network check
const validateNetwork = (setIsProgress) => {
  if (!navigator.onLine) {
    if (setIsProgress) setIsProgress(false);
    toastWithTimer(
      '<div class="styled-msg">No internet connection<strong class="redbox"></strong></div>',
      5000,
      "Network Error"
    );
    return false;
  }
  return true;
};

const makeApiCall = async (method, endpoint, data, config = {}) => {
  if (!validateNetwork(config.setIsProgress)) {
    throw new Error("NO_NETWORK");
  }

  config.setIsProgress?.(true);

  try {
    const response = await axios({
      method,
      url: endpoint,
      data: method !== "get" ? data : undefined,
      params: config.params,
      headers: config.headers,
      signal: config.signal, // ✅ AbortController
    });

    config.onSuccess?.(response);
    return response;
  } catch (error) {
    // ❌ Ignore canceled request
    if (error.code === "ERR_CANCELED") {
      return;
    }

    // ⏱ Timeout
    if (error.message === "REQUEST_TIMEOUT") {
      toastWithTimer("Request timeout. Please try again", 4000, "Timeout");
      return;
    }

    onInValidAuth(error, config.onError);
    throw error;
  } finally {
    config.setIsProgress?.(false);
  }
};

// Specific API functions - Updated to accept cancelToken
export const postFormData = (
  endpoint,
  formData,
  setIsProgress,
  onSuccess,
  onError,
  cancelToken
) => {
  return makeApiCall("post", endpoint, formData, {
    setIsProgress,
    onSuccess,
    onError,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    cancelToken,
  });
};

export const postFormDataQuery = (
  endpoint,
  formData,
  setIsProgress,
  onSuccess,
  onError,
  query,
  cancelToken
) => {
  return makeApiCall("post", endpoint, formData, {
    setIsProgress,
    onSuccess,
    onError,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: query,
    cancelToken,
  });
};

export const postJsonData = (
  endpoint,
  jsonData,
  setIsProgress,
  onSuccess,
  onError,
  cancelToken
) => {
  const hashedData = HashPayload(jsonData);
  return makeApiCall("post", endpoint, hashedData, {
    setIsProgress,
    onSuccess,
    onError,
    headers: {
      "Content-Type": "application/json",
    },
    cancelToken,
  });
};

export const get = (
  endpoint,
  queryString,
  setIsProgress,
  onSuccess,
  onError,
  cancelToken
) => {
  return makeApiCall("get", endpoint, null, {
    setIsProgress,
    onSuccess,
    onError,
    params: queryString,
    cancelToken,
  });
};

export const putJsonData = (
  endpoint,
  jsonData,
  queryString,
  setIsProgress,
  onSuccess,
  onError,
  cancelToken
) => {
  const url = queryString ? `${endpoint}${queryString}/` : endpoint;
  return makeApiCall("put", url, jsonData, {
    setIsProgress,
    onSuccess,
    onError,
    headers: {
      "Content-Type": "application/json",
    },
    cancelToken,
  });
};

export const deleteJsonData = (
  endpoint,
  jsonData,
  queryString,
  setIsProgress,
  onSuccess,
  onError,
  cancelToken
) => {
  const url = queryString ? `${endpoint}${queryString}` : endpoint;
  return makeApiCall("delete", url, jsonData, {
    setIsProgress,
    onSuccess,
    onError,
    headers: {
      "Content-Type": "application/json",
    },
    cancelToken,
  });
};

export const loginApi = (
  endpoint,
  jsonData,
  setIsProgress,
  onSuccess,
  onError
) => {
  const tempAxios = Axios.create({
    baseURL: BASE_URL,
    timeout: 30000,
  });

  if (setIsProgress) setIsProgress(true);

  return tempAxios
    .post(endpoint, jsonData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      onSuccess(response);
      return response;
    })
    .catch((error) => {
      // Don't call onError for canceled login requests
      if (!Axios.isCancel(error)) {
        onError?.(error);
      }
      throw error;
    })
    .finally(() => {
      if (setIsProgress) setIsProgress(false);
    });
};

// Add abort controller support for cancelable requests
export const createCancelTokenSource = () => {
  return Axios.CancelToken.source();
};

// Refresh axios instance when token changes
export const refreshAxiosInstance = () => {
  axios = createAxiosInstance();
  configure({ axios, cache });
  return axios;
};

// Helper to check if error is a cancelation
export const isCanceledError = (error) => {
  return Axios.isCancel(error);
};
